import { mapGetters } from 'vuex'
import axios from 'axios'
import { uid } from 'uid'

export default {
  computed: {
    ...mapGetters({
      disableTracking: 'interactions/disableTracking',
      styles: 'styleTemplate',
    })
  },

  watch: {
    isAppReady () {
      this.$nextTick(() => {
        if (!this.disableTracking) {
          const app = document.querySelector('#app')
          let dragEvents = []
          let mouseState = 'idle'
  
          // touchstart?
          app.addEventListener('mousedown', e => {
            mouseState = 'down'
            
            // normalise click coordinates to %
            const windowWidth = app.clientWidth
            const windowHeight = app.clientHeight
            const clickX = e.clientX - app.getBoundingClientRect().left
            const clickY = e.clientY - app.getBoundingClientRect().top

            const clickNormalisedX = clickX / windowWidth
            const clickNormalisedY = clickY / windowHeight
  
            // send interaction to database
            const interaction = {
              coordinates: {
                x: clickNormalisedX,
                y: clickNormalisedY,
              },
              page: this.$store.getters.activePage ? this.$store.getters.activePage._id : null,
              pageUrl: this.$route.fullPath,
              sessionId: this.$store.getters['interactions/sessionId'],
              timestamp: new Date().getTime(),
              type: 'click'
            }
  
            axios.post(process.env.VUE_APP_API_HOST + '/interactions', interaction)
          })

          app.addEventListener('mouseup', () => {
            mouseState = 'idle'

            if (dragEvents.length) {
              const interaction = {
                coordinates: {
                  x: dragEvents[0].coordinates.x,
                  y: dragEvents[0].coordinates.y,
                },
                dragInteractions: dragEvents,
                page: this.$store.getters.activePage ? this.$store.getters.activePage._id : null,
                pageUrl: this.$route.fullPath,
                sessionId: this.$store.getters['interactions/sessionId'],
                timestamp: new Date().getTime(),
                type: 'dragging'
              }

              axios.post(process.env.VUE_APP_API_HOST + '/interactions', interaction)

              dragEvents = []
            }
          })

          app.addEventListener('mousemove', e => {
            if (mouseState === 'down' || mouseState === 'drag') {
              if (mouseState === 'down') {
                dragEvents = []
                mouseState = 'drag'
              }

              // normalise click coordinates to %
              const windowWidth = app.clientWidth
              const windowHeight = app.clientHeight
              const clickX = e.clientX - app.getBoundingClientRect().left
              const clickY = e.clientY - app.getBoundingClientRect().top

              const clickNormalisedX = clickX / windowWidth
              const clickNormalisedY = clickY / windowHeight

              const interaction = {
                coordinates: {
                  x: clickNormalisedX,
                  y: clickNormalisedY,
                },
                timestamp: new Date().getTime()
              }

              // group all the drag positions together
              dragEvents.push(interaction)
            }
          })
        }
      })
    }
  },

  mounted () {
    this.$store.commit('interactions/SET_SESSION_ID', uid())

    if (this.$route.query.showHeat === 'true') {
      this.$store.commit('interactions/SET_SHOW_HEAT', true)
      this.$store.commit('interactions/SET_DISABLE_TRACKING', true)
    }

    if (this.styles['general'] && this.styles['general']['analytics'] !== 'true') {
      this.$store.commit('interactions/SET_DISABLE_TRACKING', true)
    }

    if (process.env.VUE_APP_ENV !== 'production') {
      // this.$store.commit('interactions/SET_DISABLE_TRACKING', true)
    }

    if (this.$route.query.heatStart && this.$route.query.heatEnd) {
      this.$store.commit('interactions/SET_HEAT_MAP_RANGE', {
        start: this.$route.query.heatStart,
        end: this.$route.query.heatEnd,
      })
    }

    // start playback
    if (this.$route.query.sessionId) { 
      this.$store.commit('interactions/SET_DISABLE_TRACKING', true)
      this.$store.commit('interactions/SET_SHOW_PLAYBACK', true)
      this.$store.commit('interactions/SET_PLAYBACK_ID', this.$route.query.sessionId)

      // load up session interactions
      axios.get(process.env.VUE_APP_API_HOST + '/interactions/session/' + this.$route.query.sessionId).then(res => {
        this.$store.commit('interactions/SET_SESSION_PLAYBACK', res.data)
        this.triggerInteractionsPlayback(-3000) // jesus take the wheel 🙏
      })
    }
    
  },

  methods: {
    triggerInteractionsPlayback (timestampStart) {
      var fireMouseEvent = function (type, elem, centerX, centerY) {
        var evt = new MouseEvent(type, {
          clientX: centerX,
          clientY: centerY,
          bubbles: true,
          // buttons: 1,
        })

        elem.dispatchEvent(evt)
      }

      const sessionInteractions = this.$store.state.interactions.sessionPlayback ? this.$store.state.interactions.sessionPlayback.interactions : []

      // add 3 seconds to start time
      let initialPlaybackTimestamp = new Date().getTime() - timestampStart

      let interactionIndex = 0
      let offset = initialPlaybackTimestamp - sessionInteractions[0].timestamp
      let playbackTimestamp = 0

      // current timestamp skip offset
      let skipOffset = 0

      // get session length
      let sessionLength = sessionInteractions[sessionInteractions.length - 1].timestamp - sessionInteractions[0].timestamp

      // get current playback timestamp
      let currentPlaybackTimestamp = timestampStart
      
      let playbackPercentage = 0

      let lastIntervalUpdate = new Date().getTime()
      let intervalDelta = 0

      // skipping user inactivity
      let isSkipping = false

      // set interval every 100ms
      let checkingInteractions = setInterval(() => {
        // get time difference to the next interaction
        if (sessionInteractions[interactionIndex] && sessionInteractions[interactionIndex - 1] && !isSkipping) {
          let timeDifferenceBetweenInteractions = sessionInteractions[interactionIndex].timestamp - sessionInteractions[interactionIndex - 1].timestamp

          if (timeDifferenceBetweenInteractions > 10000) {
            isSkipping = true
            skipOffset += timeDifferenceBetweenInteractions - 2000
          }
        }

        let now = new Date().getTime() + skipOffset

        intervalDelta = now - lastIntervalUpdate
        lastIntervalUpdate = now
        currentPlaybackTimestamp += intervalDelta

        playbackPercentage = (currentPlaybackTimestamp / sessionLength * 100).toFixed(2)

        this.$store.commit('interactions/UPDATE_PLAYBACK_PERCENTAGE', playbackPercentage)

        if (interactionIndex > sessionInteractions.length - 1) {
          clearInterval(checkingInteractions)
        } else {
          const app = document.querySelector('#app')

          // trigger the interaction
          if (sessionInteractions[interactionIndex].timestamp < now - offset) {
            
            // get the type of interaction
            const type = sessionInteractions[interactionIndex].type

            if (type === 'click') {
              // how much time has passed
              playbackTimestamp = sessionInteractions[interactionIndex].timestamp - sessionInteractions[0].timestamp 

              // get real coords of click
              const remX = 192 * sessionInteractions[interactionIndex].coordinates.x
              const remY = 108 * sessionInteractions[interactionIndex].coordinates.y

              const realX = remX * this.$store.state.appScale * 10 + app.getBoundingClientRect().left
              const realY = remY * this.$store.state.appScale * 10 + app.getBoundingClientRect().top

              let div = document.createElement('div')
              div.style.left = realX + 'px'
              div.style.top = realY + 'px'
              div.classList.add('interaction')

              app.appendChild(div)

              setTimeout(() => {
                div.remove()
              }, 1500)

              const el = document.elementFromPoint(realX, realY)
              fireMouseEvent('click', el, realX, realY)
            }

            if (type === 'dragging') {
              const dragInteractions = sessionInteractions[interactionIndex].dragInteractions
              const initialDragTimestamp = sessionInteractions[interactionIndex].timestamp

              let dragIndex = 0

              let offset = initialDragTimestamp - dragInteractions[dragIndex].timestamp
              let endDrag = false

              let checkingDragInteractions = setInterval(() => {
                if (dragIndex > dragInteractions.length - 1) {
                  clearInterval(checkingDragInteractions)
                  endDrag = true
                } else if (!endDrag) {
                  const app = document.querySelector('#app')
                  let currentDragTimestamp = new Date().getTime()

                  // trigger the interaction
                  if (dragInteractions[dragIndex].timestamp + offset < currentDragTimestamp) {
                    const remX = 192 * dragInteractions[dragIndex].coordinates.x
                    const remY = 108 * dragInteractions[dragIndex].coordinates.y

                    const realX = remX * this.$store.state.appScale * 10 + app.getBoundingClientRect().left
                    const realY = remY * this.$store.state.appScale * 10 + app.getBoundingClientRect().top

                    let div = document.createElement('div')
                    div.style.left = realX + 'px'
                    div.style.top = realY + 'px'
                    div.classList.add('interaction-drag')

                    app.appendChild(div)

                    setTimeout(() => {
                      div.remove()
                    }, 2000)

                    const el = document.elementFromPoint(realX, realY)
                    if (dragIndex === 0) {
                      console.log('dragging', el)
                      
                      fireMouseEvent('mousedown', el, realX, realY)
                    } 
                    
                    if (dragIndex < dragInteractions.length - 1) {
                      fireMouseEvent('mousemove', el, realX, realY)
                    }

                    if (dragIndex === dragInteractions.length - 1) {
                      fireMouseEvent('mouseup', el, realX, realY)
                    }

                    dragIndex++
                  }
                }
              }, 1)
            }

            isSkipping = false

            this.$store.commit('interactions/UPDATE_PLAYBACK_INDEX', playbackTimestamp)
            interactionIndex++
          }
        }
      }, 100)
    },

    resetInteractionSession () {
      console.log('reset interactions')
      this.$store.commit('interactions/SET_SESSION_ID', uid())
    }
  }
}
